var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ERentioFormField } from "@rentiohq/shared-frontend/dist/components/components/Form";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { EField as EEpcField } from "@rentiohq/shared-frontend/dist/forms/epc/schema.epcInfo.types";
import { getValue, } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { ELeaseType, EEpcBasedIndexationType, } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { EPropertyEPCLabel, } from "@rentiohq/shared-frontend/dist/types/property.types";
import { isBefore } from "@rentiohq/shared-frontend/dist/utils/date-fns.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { formatCurrency, getAmountWithVat, } from "@rentiohq/shared-frontend/dist/utils/number.utils";
import { isFlemishZip, isWalloonZip, } from "@rentiohq/shared-frontend/dist/utils/property.utils";
import { ts } from "../../services";
import utils from "../../utils";
import { EField } from "./schema.indexContract.types";
export var getInitialValues = function (_a) {
    var _b, _c;
    var _d;
    var contract = _a.contract, indexInfo = _a.indexInfo, letterTemplates = _a.letterTemplates, property = _a.property;
    return (__assign(__assign((_b = {}, _b[EField.CurrentPrice] = contract.currentPrice, _b[EField.CurrentCommonCosts] = contract.currentCostsCommon, _b[EField.CurrentNonCommonCosts] = contract.currentCostsNonCommon, _b), getInitialValuesForAdditionalCosts({ contract: contract, indexInfo: indexInfo })), (_c = {}, _c[EField.GenerateLetter] = true, _c[EField.LetterType] = (_d = letterTemplates === null || letterTemplates === void 0 ? void 0 : letterTemplates[0]) === null || _d === void 0 ? void 0 : _d.id, _c[EEpcField.Label] = (property === null || property === void 0 ? void 0 : property.epcLabel) || undefined, _c[EEpcField.Value] = (property === null || property === void 0 ? void 0 : property.epcValue) || undefined, _c[EEpcField.ExpirationDate] = (property === null || property === void 0 ? void 0 : property.epcExpirationDate) || undefined, _c)));
};
export var getMaximumPriceBase = function (params) {
    var indexInfo = params.indexInfo, epcLabel = params.epcLabel, epcExpired = params.epcExpired, isCommercialLease = params.isCommercialLease, forceFullIndexation = params.forceFullIndexation;
    if (forceFullIndexation || isCommercialLease) {
        return indexInfo.newPrice;
    }
    if (epcExpired) {
        return indexInfo.newPriceNoEpc;
    }
    switch (epcLabel || EPropertyEPCLabel.Unknown) {
        case EPropertyEPCLabel.APlus:
        case EPropertyEPCLabel.A:
        case EPropertyEPCLabel.B:
        case EPropertyEPCLabel.C:
            return indexInfo.newPrice;
        case EPropertyEPCLabel.D:
            return indexInfo.newPriceEpcD;
        case EPropertyEPCLabel.E:
            return indexInfo.newPriceEpcE;
        case EPropertyEPCLabel.F:
            return indexInfo.newPriceEpcF;
        case EPropertyEPCLabel.G:
            return indexInfo.newPriceEpcG;
        case EPropertyEPCLabel.Unknown:
        case EPropertyEPCLabel.NoEPCAvailable:
        default:
            return indexInfo.newPriceNoEpc;
    }
};
export var getMaxPriceParams = function (params) {
    var formData = params.formData, extraData = params.extraData;
    var forceFullIndexation = formData[EField.ForceFullIndexation] || false;
    var isCommercialLease = [
        ELeaseType.CommercialLease,
        ELeaseType.Other,
    ].includes(extraData.contract.leaseType);
    var epcExpired = checkIfEpcExpired(formData[EField.EpcExpirationDate]);
    // Price on the label the API prices on: an expired certificate, or one
    // without an expiration date, falls in the no-EPC band (SUP-4335)
    var epcLabel = getValidEpcLabel({
        epcLabel: formData[EEpcField.Label],
        epcExpirationDate: formData[EField.EpcExpirationDate],
    });
    return {
        indexInfo: extraData.indexInfo,
        epcLabel: epcLabel,
        epcExpired: epcExpired,
        isCommercialLease: isCommercialLease,
        forceFullIndexation: forceFullIndexation,
    };
};
export var getMaximumPrice = function (params) { return getMaximumPriceBase(getMaxPriceParams(params)); };
export var getMaximumCommonCostsPrice = function (params) {
    var _a = getMaxPriceParams(params), indexInfo = _a.indexInfo, epcLabel = _a.epcLabel, epcExpired = _a.epcExpired, isCommercialLease = _a.isCommercialLease, forceFullIndexation = _a.forceFullIndexation;
    if (forceFullIndexation || isCommercialLease || epcExpired) {
        return indexInfo.newCommonCostsPriceNoEpc;
    }
    switch (epcLabel || EPropertyEPCLabel.Unknown) {
        case EPropertyEPCLabel.APlus:
        case EPropertyEPCLabel.A:
        case EPropertyEPCLabel.B:
        case EPropertyEPCLabel.C:
            return indexInfo.newCommonCostsPrice;
        case EPropertyEPCLabel.D:
            return indexInfo.newCommonCostsPriceEpcD;
        case EPropertyEPCLabel.E:
            return indexInfo.newCommonCostsPriceEpcE;
        case EPropertyEPCLabel.F:
            return indexInfo.newCommonCostsPriceEpcF;
        case EPropertyEPCLabel.G:
            return indexInfo.newCommonCostsPriceEpcG;
        case EPropertyEPCLabel.Unknown:
        case EPropertyEPCLabel.NoEPCAvailable:
        default:
            return indexInfo.newCommonCostsPriceNoEpc;
    }
};
export var getMaximumNonCommonCostsPrice = function (params) {
    var _a = getMaxPriceParams(params), indexInfo = _a.indexInfo, epcLabel = _a.epcLabel, epcExpired = _a.epcExpired, isCommercialLease = _a.isCommercialLease, forceFullIndexation = _a.forceFullIndexation;
    if (forceFullIndexation || isCommercialLease || epcExpired) {
        return indexInfo.newNonCommonCostsPriceNoEpc;
    }
    switch (epcLabel || EPropertyEPCLabel.Unknown) {
        case EPropertyEPCLabel.APlus:
        case EPropertyEPCLabel.A:
        case EPropertyEPCLabel.B:
        case EPropertyEPCLabel.C:
            return indexInfo.newNonCommonCostsPrice;
        case EPropertyEPCLabel.D:
            return indexInfo.newNonCommonCostsPriceEpcD;
        case EPropertyEPCLabel.E:
            return indexInfo.newNonCommonCostsPriceEpcE;
        case EPropertyEPCLabel.F:
            return indexInfo.newNonCommonCostsPriceEpcF;
        case EPropertyEPCLabel.G:
            return indexInfo.newNonCommonCostsPriceEpcG;
        case EPropertyEPCLabel.Unknown:
        case EPropertyEPCLabel.NoEPCAvailable:
        default:
            return indexInfo.newNonCommonCostsPriceNoEpc;
    }
};
export var getMaximumAdditionalCostPrice = function (params) {
    var cost = params.cost;
    var _a = getMaxPriceParams(params), epcLabel = _a.epcLabel, epcExpired = _a.epcExpired, isCommercialLease = _a.isCommercialLease, forceFullIndexation = _a.forceFullIndexation;
    if (forceFullIndexation || isCommercialLease || epcExpired) {
        return cost.newPriceNoEpc;
    }
    switch (epcLabel || EPropertyEPCLabel.Unknown) {
        case EPropertyEPCLabel.APlus:
        case EPropertyEPCLabel.A:
        case EPropertyEPCLabel.B:
        case EPropertyEPCLabel.C:
            return cost.newPrice;
        case EPropertyEPCLabel.D:
            return cost.newPriceEpcD;
        case EPropertyEPCLabel.E:
            return cost.newPriceEpcE;
        case EPropertyEPCLabel.F:
            return cost.newPriceEpcF;
        case EPropertyEPCLabel.G:
            return cost.newPriceEpcG;
        case EPropertyEPCLabel.Unknown:
        case EPropertyEPCLabel.NoEPCAvailable:
        default:
            return cost.newPriceNoEpc;
    }
};
export var checkIfEpcExpired = function (epcExpiryDate) {
    return epcExpiryDate && isBefore(epcExpiryDate, new Date());
};
var NO_VALID_EPC_LABELS = [
    EPropertyEPCLabel.Unknown,
    EPropertyEPCLabel.NoEPCAvailable,
];
/**
 * The label the indexation is priced on, decided the way the API's
 * getValidEpcLabel decides it: a certificate without an expiration date, or
 * with one in the past, does not count and falls in the no-EPC band (SUP-4335).
 */
export var getValidEpcLabel = function (params) {
    var epcLabel = params.epcLabel, epcExpirationDate = params.epcExpirationDate;
    if (!epcLabel) {
        return EPropertyEPCLabel.Unknown;
    }
    if (!epcExpirationDate || checkIfEpcExpired(epcExpirationDate)) {
        return EPropertyEPCLabel.NoEPCAvailable;
    }
    return epcLabel;
};
/**
 * Without a valid certificate a residential lease can only be indexed in
 * Flanders (no-EPC band) and, since SUP-4335, in Wallonia (no-EPC band, as
 * the API prices it). Everywhere else, Brussels today, indexation stays
 * refused; product asked to keep that rule as it is.
 */
export var isIndexationBlockedWithoutValidEpc = function (params) {
    var property = params.property, isCommercialLease = params.isCommercialLease, validEpcLabel = params.validEpcLabel;
    if (isCommercialLease) {
        return false;
    }
    if (!NO_VALID_EPC_LABELS.includes(validEpcLabel)) {
        return false;
    }
    var zip = property === null || property === void 0 ? void 0 : property.zip;
    if (!zip) {
        return true;
    }
    return !isFlemishZip(zip) && !isWalloonZip(zip);
};
/**
 * Whether the band the contract is priced in still gives an increase. One
 * rule for the form schema and the dashboard modal, so the two cannot drift.
 */
export var canIndexForEpcLabel = function (params) {
    var indexInfo = params.indexInfo, validEpcLabel = params.validEpcLabel, isCommercialLease = params.isCommercialLease, forceFullIndexation = params.forceFullIndexation;
    if (forceFullIndexation || isCommercialLease) {
        return indexInfo.increase !== 0;
    }
    switch (validEpcLabel) {
        case EPropertyEPCLabel.APlus:
        case EPropertyEPCLabel.A:
        case EPropertyEPCLabel.B:
        case EPropertyEPCLabel.C:
            return indexInfo.increase !== 0;
        case EPropertyEPCLabel.D:
            return indexInfo.increaseEpcD !== 0;
        case EPropertyEPCLabel.E:
            return indexInfo.increaseEpcE !== 0;
        case EPropertyEPCLabel.F:
            return indexInfo.increaseEpcF !== 0;
        case EPropertyEPCLabel.G:
            return indexInfo.increaseEpcG !== 0;
        case EPropertyEPCLabel.Unknown:
        case EPropertyEPCLabel.NoEPCAvailable:
        default:
            return indexInfo.increaseNoEpc !== 0;
    }
};
export var calculatePartiallyIndexedCost = function (params) {
    var currentPrice = params.currentPrice, userInput = params.userInput, currentCost = params.currentCost;
    var factor = userInput / currentPrice;
    return currentCost * factor;
};
export var getInitialValuesForAdditionalCosts = function (_a) {
    var contract = _a.contract, indexInfo = _a.indexInfo;
    var additionalCosts = indexInfo.additionalCosts || [];
    if (!additionalCosts.length) {
        return {};
    }
    var values = {};
    additionalCosts.forEach(function (cost) {
        var _a, _b;
        var fieldKey = "additional-cost-".concat(cost.index);
        values[fieldKey] = (_b = (_a = contract.additionalCosts) === null || _a === void 0 ? void 0 : _a[cost.index]) === null || _b === void 0 ? void 0 : _b.currentPrice;
    });
    return values;
};
export var getIndexableAdditionalCosts = function (additionalCosts) { return additionalCosts.filter(function (cost) { return cost.isIndexable; }); };
export var getAdditionalCostFieldsSchema = function (_a) {
    var extraData = _a.extraData, initialValues = _a.initialValues, defaultValues = _a.defaultValues;
    var additionalCosts = extraData.indexInfo.additionalCosts || [];
    if (!additionalCosts.length) {
        return {};
    }
    var schemas = {};
    additionalCosts.forEach(function (cost) {
        var fieldKey = "additional-cost-".concat(cost.index);
        schemas[fieldKey] = {
            default: getValue(fieldKey, initialValues, defaultValues),
            showIf: function () { return true; },
        };
    });
    return schemas;
};
export var getAdditionalCostFieldsUiSchema = function (_a) {
    var extraData = _a.extraData;
    var additionalCosts = extraData.indexInfo.additionalCosts || [];
    if (!additionalCosts.length) {
        return {};
    }
    var uiSchemas = {};
    additionalCosts.forEach(function (cost) {
        var fieldKey = "additional-cost-".concat(cost.index);
        uiSchemas[fieldKey] = {
            "ui:field": ERentioFormField.Number,
            title: cost.description,
            suffixText: "EUR",
            isFloat: true,
            decimals: CONFIG.DECIMALS_FOR_CURRENCY,
            readOnly: true,
        };
    });
    return uiSchemas;
};
export var getAdditionalCostsGridDistribution = function (_a) {
    var extraData = _a.extraData;
    var additionalCosts = extraData.indexInfo.additionalCosts || [];
    if (!additionalCosts.length) {
        return [];
    }
    var gridDistribution = additionalCosts.map(function (cost) {
        var fieldKey = "additional-cost-".concat(cost.index);
        return {
            col: {
                width: [1],
                children: [fieldKey],
            },
        };
    });
    return gridDistribution;
};
export var getNewAdditionalCostFieldsSchema = function (_a) {
    var extraData = _a.extraData, defaultValues = _a.defaultValues;
    var additionalCosts = extraData.indexInfo.additionalCosts || [];
    if (!additionalCosts.length) {
        return {};
    }
    var schemas = {};
    additionalCosts.forEach(function (cost) {
        var fieldKey = "additional-cost-".concat(cost.index);
        var newFieldKey = "new-additional-cost-".concat(cost.index);
        schemas[newFieldKey] = {
            default: (function () {
                if (!defaultValues[fieldKey]) {
                    return;
                }
                return Number(getMaximumAdditionalCostPrice({
                    formData: defaultValues,
                    extraData: extraData,
                    cost: cost,
                }).toFixed(2));
            })(),
            // @ts-ignore
            showIf: function () { return true; },
            requiredIf: function () { return true; },
            minimum: 0,
            getMaximum: function (formData) {
                return getMaximumAdditionalCostPrice({ formData: formData, extraData: extraData, cost: cost });
            },
            handleChange: function (fieldName, _fieldValue, _myFieldValue, formData) {
                if (fieldName === newFieldKey) {
                    extraData.lockedAdditionalCostIndices.add(cost.index);
                    return { shouldSetNewValue: false };
                }
                if (fieldName !== EField.NewPrice) {
                    return { shouldSetNewValue: false };
                }
                var maxNewPrice = getMaximumPrice({ formData: formData, extraData: extraData });
                var currentNewPrice = formData[EField.NewPrice];
                if (extraData.lockedAdditionalCostIndices.has(cost.index)) {
                    return { shouldSetNewValue: false };
                }
                if (currentNewPrice >= maxNewPrice) {
                    return {
                        shouldSetNewValue: true,
                        newValue: Number(getMaximumAdditionalCostPrice({
                            formData: formData,
                            extraData: extraData,
                            cost: cost,
                        }).toFixed(2)),
                    };
                }
                return {
                    shouldSetNewValue: true,
                    newValue: Number(calculatePartiallyIndexedCost({
                        currentPrice: formData[EField.CurrentPrice],
                        userInput: currentNewPrice,
                        currentCost: formData[fieldKey],
                    }).toFixed(2)),
                };
            },
        };
    });
    return schemas;
};
export var getNewAdditionalCostFieldsUiSchema = function (_a) {
    var extraData = _a.extraData;
    var additionalCosts = extraData.indexInfo.additionalCosts || [];
    if (!additionalCosts.length) {
        return {};
    }
    var uiSchemas = {};
    additionalCosts.forEach(function (cost) {
        var fieldKey = "new-additional-cost-".concat(cost.index);
        uiSchemas[fieldKey] = {
            "ui:field": ERentioFormField.Number,
            title: getLocalizedText("indexation.new_price.label", {
                label: cost.description || "",
            }),
            suffixText: "EUR",
            isFloat: true,
            decimals: CONFIG.DECIMALS_FOR_CURRENCY,
            getInfo: function (formData) {
                var maxPrice = getMaximumAdditionalCostPrice({
                    formData: formData,
                    extraData: extraData,
                    cost: cost,
                });
                return ts.contractIndexPriceNewDescription({
                    values: { maximumPrice: formatCurrency(maxPrice) },
                });
            },
        };
    });
    return uiSchemas;
};
export var canIndex = function (formData, extraData) {
    var indexInfo = extraData.indexInfo, property = extraData.property, isCommercialLease = extraData.isCommercialLease;
    var forceFullIndexation = formData[EField.ForceFullIndexation];
    var validEpcLabel = getValidEpcLabel({
        epcLabel: formData[EEpcField.Label],
        epcExpirationDate: formData[EField.EpcExpirationDate],
    });
    if (!forceFullIndexation &&
        isIndexationBlockedWithoutValidEpc({
            property: property,
            isCommercialLease: isCommercialLease,
            validEpcLabel: validEpcLabel,
        })) {
        return false;
    }
    return canIndexForEpcLabel({
        indexInfo: indexInfo,
        validEpcLabel: validEpcLabel,
        isCommercialLease: isCommercialLease,
        forceFullIndexation: forceFullIndexation,
    });
};
/**
 * The "force full indexation" switch is offered whenever the rent is not
 * priced at the full index: a D to G label, or no valid certificate at all.
 * Same band selection as the pricing, so an expired certificate and one
 * without an expiration date both count as no valid EPC (SUP-4335).
 */
export var showForceFullIndexation = function (formData) {
    if (!formData[EEpcField.Label]) {
        return false;
    }
    var validEpcLabel = getValidEpcLabel({
        epcLabel: formData[EEpcField.Label],
        epcExpirationDate: formData[EField.EpcExpirationDate],
    });
    return __spreadArray([
        EPropertyEPCLabel.D,
        EPropertyEPCLabel.E,
        EPropertyEPCLabel.F,
        EPropertyEPCLabel.G
    ], NO_VALID_EPC_LABELS, true).includes(validEpcLabel);
};
export var showEpcBasedLimitationInfoSubtitle = function (formData, extraData) {
    var indexInfo = extraData.indexInfo;
    var epcLabel = (formData[EEpcField.Label] ||
        EPropertyEPCLabel.Unknown);
    // Same band selection as the pricing: an expired certificate, or one
    // without an expiration date, falls in the no-EPC band (SUP-4335)
    var validEpcLabel = getValidEpcLabel({
        epcLabel: formData[EEpcField.Label],
        epcExpirationDate: formData[EField.EpcExpirationDate],
    });
    if (NO_VALID_EPC_LABELS.includes(validEpcLabel)) {
        return true;
    }
    if (indexInfo.epcBasedIndexationType === EEpcBasedIndexationType.Regular) {
        return false;
    }
    var forceFullIndexation = formData[EField.ForceFullIndexation];
    if (forceFullIndexation) {
        return true;
    }
    var newPrice = indexInfo.newPrice;
    switch (epcLabel) {
        case EPropertyEPCLabel.APlus:
        case EPropertyEPCLabel.A:
        case EPropertyEPCLabel.B:
        case EPropertyEPCLabel.C:
            break;
        case EPropertyEPCLabel.D:
            newPrice = indexInfo.newPriceEpcD;
            break;
        case EPropertyEPCLabel.E:
            newPrice = indexInfo.newPriceEpcE;
            break;
        case EPropertyEPCLabel.F:
            newPrice = indexInfo.newPriceEpcF;
            break;
        case EPropertyEPCLabel.G:
            newPrice = indexInfo.newPriceEpcG;
            break;
        case EPropertyEPCLabel.Unknown:
        case EPropertyEPCLabel.NoEPCAvailable:
        default:
            newPrice = indexInfo.newPriceNoEpc;
            break;
    }
    return newPrice !== indexInfo.newPrice;
};
export var getEpcBasedLimitationInfoSubtitle = function (extraData) { return function (state, formData) {
    var indexInfo = extraData.indexInfo, property = extraData.property, contract = extraData.contract;
    var forceFullIndexation = formData[EField.ForceFullIndexation];
    if (forceFullIndexation) {
        return getLocalizedText("contract.index.epc_info.force_full");
    }
    var epcKey;
    var correctionFactorForEpc;
    var newPriceForEpc;
    var increaseForEpc;
    var epcLabel = formData[EEpcField.Label];
    var validEpcLabel = getValidEpcLabel({
        epcLabel: epcLabel,
        epcExpirationDate: formData[EField.EpcExpirationDate],
    });
    // A real label whose certificate does not count (expired or no date)
    var epcExpired = !!epcLabel &&
        !NO_VALID_EPC_LABELS.includes(epcLabel) &&
        validEpcLabel === EPropertyEPCLabel.NoEPCAvailable;
    switch (epcLabel) {
        case EPropertyEPCLabel.APlus:
        case EPropertyEPCLabel.A:
        case EPropertyEPCLabel.B:
        case EPropertyEPCLabel.C:
            // Info banner not shown since default indexation is allowed
            break;
        case EPropertyEPCLabel.D:
            newPriceForEpc = indexInfo.newPriceEpcD;
            increaseForEpc = indexInfo.increaseEpcD;
            correctionFactorForEpc = indexInfo.correctionFactorEpcD;
            if (indexInfo.epcBasedIndexationType === EEpcBasedIndexationType.Corrected) {
                epcKey = "contract.index.epc_info.epc.corrected";
                break;
            }
            break;
        case EPropertyEPCLabel.E:
            newPriceForEpc = indexInfo.newPriceEpcE;
            increaseForEpc = indexInfo.increaseEpcE;
            correctionFactorForEpc = indexInfo.correctionFactorEpcE;
            if (indexInfo.epcBasedIndexationType === EEpcBasedIndexationType.Corrected) {
                epcKey = "contract.index.epc_info.epc.corrected";
                break;
            }
            break;
        case EPropertyEPCLabel.F:
            newPriceForEpc = indexInfo.newPriceEpcF;
            increaseForEpc = indexInfo.increaseEpcF;
            correctionFactorForEpc = indexInfo.correctionFactorEpcF;
            if (indexInfo.epcBasedIndexationType === EEpcBasedIndexationType.Corrected) {
                epcKey = "contract.index.epc_info.epc.corrected";
                break;
            }
            break;
        case EPropertyEPCLabel.G:
            newPriceForEpc = indexInfo.newPriceEpcG;
            increaseForEpc = indexInfo.increaseEpcG;
            correctionFactorForEpc = indexInfo.correctionFactorEpcG;
            if (indexInfo.epcBasedIndexationType === EEpcBasedIndexationType.Corrected) {
                epcKey = "contract.index.epc_info.epc.corrected";
                break;
            }
            break;
        case EPropertyEPCLabel.Unknown:
        case EPropertyEPCLabel.NoEPCAvailable:
        default:
            newPriceForEpc = indexInfo.newPriceNoEpc;
            increaseForEpc = indexInfo.increaseNoEpc;
            correctionFactorForEpc = indexInfo.correctionFactorNoEpc;
            if ([ELeaseType.CommercialLease, ELeaseType.Other].includes(contract.leaseType)) {
                epcKey = "contract.index.epc_info.contract.lease_type.commercial";
                break;
            }
            if (indexInfo.epcBasedIndexationType === EEpcBasedIndexationType.Corrected) {
                epcKey = "contract.index.epc_info.epc_unknown.corrected";
                break;
            }
            break;
    }
    if (epcExpired) {
        newPriceForEpc = indexInfo.newPriceNoEpc;
        increaseForEpc = indexInfo.increaseNoEpc;
        correctionFactorForEpc = indexInfo.correctionFactorNoEpc;
        if (indexInfo.epcBasedIndexationType === EEpcBasedIndexationType.Corrected) {
            epcKey = "contract.index.epc_info.epc_expired.corrected";
        }
    }
    if (isIndexationBlockedWithoutValidEpc({
        property: property,
        isCommercialLease: [
            ELeaseType.CommercialLease,
            ELeaseType.Other,
        ].includes(contract.leaseType),
        validEpcLabel: validEpcLabel,
    })) {
        return getLocalizedText("contract.index.not_allowed");
    }
    if (epcKey) {
        return getLocalizedText(epcKey, {
            epcLabel: getLocalizedText("epc.label.".concat(epcLabel).toLowerCase()),
            correctionFactor: correctionFactorForEpc
                ? "".concat(correctionFactorForEpc.toFixed(3))
                : "",
            newPriceBase: formatCurrency(indexInfo.newPrice),
            increaseBase: formatCurrency(indexInfo.increase),
            newPriceForEpc: newPriceForEpc ? formatCurrency(newPriceForEpc) : "",
            increaseForEpc: increaseForEpc ? formatCurrency(increaseForEpc) : "",
        });
    }
}; };
export var getDefaultTotal = function (formData, extraData) {
    var contract = extraData.contract;
    var currentPrice = contract.currentPrice, _a = contract.priceVat, priceVat = _a === void 0 ? 0 : _a, _b = contract.costsCommonVat, costsCommonVat = _b === void 0 ? 0 : _b, _c = contract.costsNonCommonVat, costsNonCommonVat = _c === void 0 ? 0 : _c, _d = contract.currentCostsCommon, currentCostsCommon = _d === void 0 ? 0 : _d, commonCostsAreIndexable = contract.commonCostsAreIndexable, nonCommonCostsAreIndexable = contract.nonCommonCostsAreIndexable, _e = contract.currentCostsNonCommon, currentCostsNonCommon = _e === void 0 ? 0 : _e, additionalCosts = contract.additionalCosts;
    var indexedCost = getMaximumPrice({ formData: formData, extraData: extraData });
    var adjustedCommonCost = commonCostsAreIndexable
        ? calculatePartiallyIndexedCost({
            currentPrice: currentPrice,
            userInput: indexedCost,
            currentCost: currentCostsCommon,
        })
        : currentCostsCommon;
    var adjustedNonCommonCost = nonCommonCostsAreIndexable
        ? calculatePartiallyIndexedCost({
            currentPrice: currentPrice,
            userInput: indexedCost,
            currentCost: currentCostsNonCommon,
        })
        : currentCostsNonCommon;
    var newPrice = getAmountWithVat(indexedCost || 0, priceVat / 100);
    var newCommonCosts = getAmountWithVat(adjustedCommonCost || 0, costsCommonVat / 100);
    var newNonCommonCosts = getAmountWithVat(adjustedNonCommonCost || 0, costsNonCommonVat / 100);
    var additionalCostsTotal = 0;
    var indexInfoAdditionalCosts = extraData.indexInfo.additionalCosts || [];
    indexInfoAdditionalCosts.forEach(function (cost) {
        var _a, _b;
        var priceVat = (_b = (_a = additionalCosts === null || additionalCosts === void 0 ? void 0 : additionalCosts[cost.index]) === null || _a === void 0 ? void 0 : _a.priceVat) !== null && _b !== void 0 ? _b : 0;
        var adjustedCost = getMaximumAdditionalCostPrice({
            formData: formData,
            extraData: extraData,
            cost: cost,
        });
        var newCostWithVat = getAmountWithVat(adjustedCost || 0, priceVat / 100);
        additionalCostsTotal += newCostWithVat;
    });
    return (newPrice +
        newCommonCosts +
        newNonCommonCosts +
        additionalCostsTotal).toFixed(2);
};
export var getActualTotal = function (formData, extraData) {
    var contract = extraData.contract;
    var _a = contract.priceVat, priceVat = _a === void 0 ? 0 : _a, _b = contract.costsCommonVat, costsCommonVat = _b === void 0 ? 0 : _b, _c = contract.costsNonCommonVat, costsNonCommonVat = _c === void 0 ? 0 : _c, _d = contract.currentCostsCommon, currentCostsCommon = _d === void 0 ? 0 : _d, _e = contract.currentCostsNonCommon, currentCostsNonCommon = _e === void 0 ? 0 : _e, commonCostsAreIndexable = contract.commonCostsAreIndexable, nonCommonCostsAreIndexable = contract.nonCommonCostsAreIndexable, additionalCosts = contract.additionalCosts;
    var adjustedCommonCost = commonCostsAreIndexable
        ? calculatePartiallyIndexedCost({
            currentPrice: formData[EField.CurrentPrice],
            userInput: formData[EField.NewPrice],
            currentCost: formData[EField.CurrentCommonCosts],
        })
        : currentCostsCommon;
    var adjustedNonCommonCost = nonCommonCostsAreIndexable
        ? calculatePartiallyIndexedCost({
            currentPrice: formData[EField.CurrentPrice],
            userInput: formData[EField.NewPrice],
            currentCost: formData[EField.CurrentNonCommonCosts],
        })
        : currentCostsNonCommon;
    var newPrice = getAmountWithVat(formData[EField.NewPrice] || 0, priceVat / 100);
    var newCommonCosts = getAmountWithVat(adjustedCommonCost || 0, costsCommonVat / 100);
    var newNonCommonCosts = getAmountWithVat(adjustedNonCommonCost || 0, costsNonCommonVat / 100);
    var additionalCostsTotal = 0;
    var indexInfoAdditionalCosts = extraData.indexInfo.additionalCosts || [];
    indexInfoAdditionalCosts.forEach(function (cost) {
        var _a, _b;
        var fieldKey = "new-additional-cost-".concat(cost.index);
        var costPriceVat = (_b = (_a = additionalCosts === null || additionalCosts === void 0 ? void 0 : additionalCosts[cost.index]) === null || _a === void 0 ? void 0 : _a.priceVat) !== null && _b !== void 0 ? _b : 0;
        var newCostWithVat = getAmountWithVat(formData[fieldKey] || 0, costPriceVat / 100);
        additionalCostsTotal += newCostWithVat;
    });
    return (newPrice +
        newCommonCosts +
        newNonCommonCosts +
        additionalCostsTotal).toFixed(2);
};
export var getLegalTotalInfoSubtitle = function (extraData, initialValues) {
    return function (state, formData) {
        var total = getDefaultTotal(formData, extraData);
        return getLocalizedText("contract.index.legally_adjusted_total.details", {
            total: formatCurrency(+total),
        });
    };
};
export var getAdjustedRetroactiveAmountLabel = function (extraData) {
    var indexInfo = extraData.indexInfo;
    var retroactivityPrice = indexInfo.retroactivityPrice, retroactivityMonths = indexInfo.retroactivityMonths, retroactivityPeriodEnd = indexInfo.retroactivityPeriodEnd, retroactivityPeriodStart = indexInfo.retroactivityPeriodStart;
    return ts.contractIndexRetroactivity({
        values: {
            retroactiveMonths: retroactivityMonths || 0,
            retroactivePrice: formatCurrency(retroactivityPrice || 0),
            retroactivityPeriodEnd: retroactivityPeriodEnd
                ? utils.date.format(retroactivityPeriodEnd)
                : "",
            retroactivityPeriodStart: retroactivityPeriodStart
                ? utils.date.format(retroactivityPeriodStart)
                : "",
        },
    });
};
